import { render, staticRenderFns } from "./FirstFrame.vue?vue&type=template&id=da623df6&scoped=true&"
import script from "./FirstFrame.vue?vue&type=script&lang=js&"
export * from "./FirstFrame.vue?vue&type=script&lang=js&"
import style0 from "./FirstFrame.vue?vue&type=style&index=0&id=da623df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da623df6",
  null
  
)

export default component.exports